import {customerDeviceIdentity} from '../../../shared/customer-review-display.js';
import {DeviceStatusCard} from '../components/DeviceStatusCard';
import {modelName} from '../../../shared/model-products.js';
import {hasFeature,hasAlarmTab,alarmFeatureIds} from '../../../shared/device-profile.js';
import {ButtonRow} from '../../ButtonLayout';
import { useLive } from '../live';
import { Text } from '../copy';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import type { QsmartActions } from '../domain/types';
import { featuresForTab } from '../domain/featureCatalog';
import { useTokens } from '../theme/tokens';
import { FeatureList, FeatureRows } from '../components/FeatureList';
import { GpsFeatureMenu } from './GpsFeaturesScreen';
import { Button, Card, Eyebrow, Metric, Pill, Screen, SectionTitle, Title } from '../components/primitives';

export function DeviceScreen({ actions }: { actions: QsmartActions }) {
  const {tracker,locale,state} = useLive();
  const device=state.snapshot?.device, gps=device?.profile?.protocol==='gt06',personal=device?.profile?.kind==='bracelet';
  const alarms=hasAlarmTab(device);
  const general=featuresForTab('device').filter(f=>['device-info','device-account','device-app-settings','device-help'].includes(f.id));
  const tokens = useTokens(), {colors,design,radius,shadows,spacing,touch,type} = tokens;
  const styles = makeStyles(tokens);
  return (
    <Screen testID="device-screen">
      <Title subtitle={`${modelName(device?.profile)}\n${locale==="da-DK"?(personal?"Redigér armbåndets indstillinger.":"Se status og redigér trackerens indstillinger."):"View status and edit device settings."}\n${locale==="da-DK"?"IMEI / producent-ID:":"IMEI / manufacturer ID:"} ${customerDeviceIdentity(device)??"—"}`}>Enhed</Title>
      <DeviceStatusCard>
        {(hasFeature(device,'find')||hasFeature(device,'calling'))&&<ButtonRow columns={2}>{hasFeature(device,'find')&&<Button label={personal?'Find armbånd':'Find tracker'} icon="find-device" tone="brand" onPress={() => actions.openScreen('device-find')} />}{hasFeature(device,'calling')&&<Button label={personal?'Ring til armbånd':'Ring til tracker'} icon="call" tone="brand" onPress={() => actions.callTracker(tracker.phoneNumber ?? '')} />}</ButtonRow>}
      </DeviceStatusCard>
      {!alarms&&<Button label={locale==='da-DK'?'Batterinotifikationer':'Battery notifications'} icon="battery" tone="secondary" onPress={()=>actions.openScreen(gps?'gps-notifications':'events-notifications')}/>}
      {gps&&!alarms&&device?.profile?.timeZoneConfirmed===false&&<Card tone="attention"><Text style={{color:colors.text,fontSize:type.body}}>Sikkerhedszoner og hastighedsalarmer er ikke klar endnu. Kontakt Qtracker for at færdiggøre opsætningen.</Text></Card>}
      <SectionTitle>{personal?'Armbånd og konto':'Tracker og konto'}</SectionTitle>
      {gps?<GpsFeatureMenu section="device"><FeatureRows features={general} onOpen={actions.openScreen}/></GpsFeatureMenu>:<FeatureList features={featuresForTab('device').filter(f=>!alarms||!alarmFeatureIds.includes(f.id))} onOpen={actions.openScreen} />}
    </Screen>
  );
}

const makeStyles = ({colors,design,radius,shadows,spacing,touch,type}: ReturnType<typeof useTokens>) => StyleSheet.create({
  deviceHeading: { flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: spacing.sm },
  deviceIcon: { width: design.accessible ? 68 : 52, height: design.accessible ? 68 : 52, borderRadius: 999, backgroundColor: colors.primary, alignItems: 'center', justifyContent: 'center' },
  grow: { flexGrow: 1, flexBasis: 140, minWidth: 0, gap: 3 },
  name: { color: colors.text, fontSize: type.heading, fontWeight: '800' },
  meta: { color: colors.textMuted, fontSize: type.body },
  metrics: { flexDirection: 'row', flexWrap: 'wrap', gap: spacing.md },
  actions: { flexDirection: design.accessible ? 'column' : 'row', gap: spacing.sm },
});

export const useStyles = () => makeStyles(useTokens());
